<template>
  <FileContent :key="columnKey" :columnKey="columnKey" :isFolderDetail="true"></FileContent>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter, onBeforeRouteUpdate } from 'vue-router';
import FileContent from '../home/index.vue';

const { currentRoute } = useRouter();
const columnKey = ref(currentRoute.value.query.key);
onBeforeRouteUpdate((to, from, next) => {
  columnKey.value = to.query.key;
  next();
});
</script>

<style lang="scss" scoped>
.folder_detail {
  height: 100vh;

  padding: 55px 40px 0;
  overflow: auto;
  .file-wrapper {
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(auto-fill, 165px);
    grid-template-row: repeat(auto-fill, 165px);
    .file {
      margin-bottom: 10px;
    }
  }
  .breadcrumb_navigation {
    position: relative;
    display: flex;
    border-bottom: 1px solid $grey4;
    .file_operation {
      display: flex;
      align-items: center;
    }
    .add_lyrics,
    .delete_btn {
      font-size: 19px;
      font-weight: 500;
    }
    .add_lyrics {
      color: #3a89ff;
    }
    .delete_btn {
      color: $red1;
      font-size: 17px;
      margin-left: 30px;
    }
    .breadcrumb,
    .choose_count {
      font-weight: bold;
      color: $grey2;
      font-size: 19px;
    }
    .choose_count {
      margin-left: 30px;
      margin-right: 30px;
      font-weight: 500;
      .num {
        color: $red1;
      }
    }
  }
}
</style>
